
import api from "@/service/api";
import store from "@/store";
import SessionsModule from "@/store/modules/Sessions";
import UserModule from "@/store/modules/User";
import Vue from "vue";
import Component from 'vue-class-component';
import { getModule } from "vuex-module-decorators";
import OrderDetails from "./OrderDetails.vue";
import SingleOrders from "./SingleOrders.vue";
import eventBroadcaster from '@/service/eventBroadcaster';

const sessionsModule = getModule(SessionsModule, store);
const userModule = getModule(UserModule, store);

interface OrderItem {
    orderId: string;
    sessionId: string;
    fullName: string;
    email: string;
    createdAt: string;
    price: string;
    chosenPrints: string;
    status: 'unpaid'|'paid'|'refund'|'cancelled'|'inprint'|'sent';
}

@Component({
    components: {
        OrderDetails,
        SingleOrders,
    }
})
export default class OrdersTab extends Vue {
    orders: { [sessionId: string]: Array<OrderItem> } = {};
    search: string = '';
    isLoading: boolean = true;
    selectedOrderIdsBySession: { [sessionId: string]: string[] } = {};
    private ordersRequestId = 0;
    private orderPlacedListener = () => { this.loadOrders(); };

    get sessions() {
        return sessionsModule.sessionList[userModule.user!.id] || [];
    }

    get anySelectedOrderIds() {
        return Object.values(this.selectedOrderIdsBySession).flat();
    }

    orderPrints() {
        alert('Zamów odbitki: ' + this.anySelectedOrderIds.join(', '));
    }

    deleteOrders() {
        if (confirm(`Czy na pewno chcesz zarchiwizować ${this.anySelectedOrderIds.length} zamówień?`)) {
            alert('Archiwizuj zamówienia: ' + this.anySelectedOrderIds.join(', '));
        }
    }

    filteredOrders(session: any) {
        if (!this.search) return this.orders[session.id] || [];
        const phrase = this.search.toLowerCase();
        // If session name matches, return all orders for this session
        if (session.name?.toLowerCase().includes(phrase)) {
            return this.orders[session.id] || [];
        }
        // Otherwise, filter orders as before
        return (this.orders[session.id] || []).filter(order => {
            return (
                order.fullName?.toLowerCase().includes(phrase) ||
                order.email?.toLowerCase().includes(phrase) ||
                order.price?.toLowerCase().includes(phrase) ||
                String(order.chosenPrints).toLowerCase().includes(phrase) ||
                order.status?.toLowerCase().includes(phrase)
            );
        });
    }

    get filteredSessions() {
        if (!this.search) {
            return this.sessions.filter(({ id }) => (this.orders[id] || []).length > 0);
        }
        // Only sessions with at least one matching order or session name
        return this.sessions.filter(session => this.filteredOrders(session).length > 0);
    }

    mounted() {
        eventBroadcaster.registerListener('raws.event.session.orderPlaced', this.orderPlacedListener);
        this.loadOrders();
    }

    beforeDestroy() {
        eventBroadcaster.removeListener('raws.event.session.orderPlaced', this.orderPlacedListener);
    }

    async loadOrders() {
        const requestId = ++this.ordersRequestId;
        this.isLoading = true;
        try {
            const orders = (await api.getOrders() as unknown as OrderItem[]).reduce((carry, item) => ({
                ...carry,
                [item.sessionId]: [ ...(carry[item.sessionId] || []), item ]
            }), {} as { [sessionId: string]: Array<OrderItem> });
            if (requestId === this.ordersRequestId) this.orders = orders;
        } catch (error) {
            console.error('Error loading orders:', error);
        } finally {
            if (requestId === this.ordersRequestId) this.isLoading = false;
        }
    }
}
